/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "proto/integration_vendor/models.proto" (package "rd.proto.integration_vendor", syntax proto3)
// tslint:disable
// @ts-nocheck
/**
 * IntegrationVendor is the vendor integration type shared across modules.
 *
 * @generated from protobuf enum rd.proto.integration_vendor.IntegrationVendor
 */
export enum IntegrationVendor {
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_BENJAMIN_MOORE = 1;
     */
    BENJAMIN_MOORE = 1,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_BENJAMIN_MOORE_TEST = 2;
     */
    BENJAMIN_MOORE_TEST = 2,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_TRUE_VALUE_CORP = 3;
     */
    TRUE_VALUE_CORP = 3,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_ALL_PRO = 5;
     */
    ALL_PRO = 5,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_EMERY_JENSEN = 7;
     */
    EMERY_JENSEN = 7,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_ORGILL = 9;
     */
    ORGILL = 9,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_DO_IT_BEST = 11;
     */
    DO_IT_BEST = 11,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_HOUSE_HASSON = 13;
     */
    HOUSE_HASSON = 13,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_BUTTERY = 15;
     */
    BUTTERY = 15,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_WALLACE = 17;
     */
    WALLACE = 17,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_LANCASTER = 19;
     */
    LANCASTER = 19,
    /**
     * PPC
     *
     * @generated from protobuf enum value: INTEGRATION_VENDOR_PITTS_PAINTS = 21;
     */
    PITTS_PAINTS = 21,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_PACOA = 23;
     */
    PACOA = 23,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_BLISH_MIZE = 25;
     */
    BLISH_MIZE = 25,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_FLORIDA_HARDWARE = 27;
     */
    FLORIDA_HARDWARE = 27,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_ORGILL_RDC = 29;
     */
    ORGILL_RDC = 29,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_BENJAMIN_MOORE_DEMO = 30;
     */
    BENJAMIN_MOORE_DEMO = 30,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_ORGILL_DEMO = 31;
     */
    ORGILL_DEMO = 31,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_EMERY_JENSEN_DEMO = 32;
     */
    EMERY_JENSEN_DEMO = 32,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_ALL_PRO_DEMO = 33;
     */
    ALL_PRO_DEMO = 33,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_TRUE_VALUE_DEMO = 34;
     */
    TRUE_VALUE_DEMO = 34,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_DO_IT_BEST_DEMO = 35;
     */
    DO_IT_BEST_DEMO = 35,
    /**
     * @generated from protobuf enum value: INTEGRATION_VENDOR_INVALID = 36;
     */
    INVALID = 36
}
